import React, {Component} from 'react'
import {Row, Col, Grid, Image} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import showToastr from '../../../utils/showToastr'
import {MdClear, MdStars, FaPencil, FaMagnet, MdLockOutline, MdLoupe, IahoAddHorse, MdFavorite, FaBalanceScale, FaFlag, MdPersonAdd, FaSingIn, FaSingOut, MdNotifications, MdShoppingCart, FaTelegram, MdDashboard} from '../../Common/ReactIcons/icons'
import {browserHistory} from 'react-router'

import './Layout/MobileNavigation.css'

const avatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`
const logo = `https://${window.location.host}/MiniLogo.png`

class MobileNavigation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user,
      width: -350,
      isOpen: false
    }
    this.toggleNav = this.toggleNav.bind(this)
  }

  carrier (path = '/') {
    this.toggleNav()
    setTimeout(() => { browserHistory.push(path) }, 300)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  toggleNav () {
    if (this.state.isOpen) {
      this.setState({isOpen: false, width: -350})
    } else {
      this.setState({isOpen: true, width: 0})
    }
  }

  render () {
    const {user, isOpen} = this.state
    const logout = () => {
      Actions.logout()
      showToastr('info', 'خروج', 'شما از سیستم خارج شدید')
    }
    const {isAuthenticated} = this.props.auth
    return (
      <div>
        <div className="mobile-nav navbar-toggle collapsed" onClick={this.toggleNav}>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </div>
        {isOpen && <div id="mobile-navigation-back" onClick={this.toggleNav} />}
        <Grid id="mobile-navigation" style={{right: this.state.width}}>
          <div className="closebtn" onClick={this.toggleNav}><MdClear /></div>
          {(isAuthenticated && user.currentUser)
            ? <Row>
              <Col xs={4}>
                <a onClick={() => this.carrier('/user/profile')}><Image className="avatar" src={user.currentUser.avatar.thumb ? user.currentUser.avatar.thumb : avatar} circle /></a>
              </Col>
              <Col xs={8} className="detailsHolder">
                <a onClick={() => this.carrier('/user/profile')} className="username">{user.currentUser.full_name != null ? user.currentUser.full_name : user.currentUser.username}</a>
                <Row className="details">
                  <Col className="horseshoe" xs={6}><a onClick={() => this.carrier('/user/profile')}><FaMagnet />{user.currentUser.point}</a></Col>
                  <Col className="notification" xs={6}><a onClick={() => this.carrier('/user/notification')}><MdNotifications />{user.currentUser.notification}</a></Col>
                </Row>
              </Col>
            </Row> : <Row>
              <Col xs={2} />
              <Col xs={10} className="detailsHolder logo">
                <a onClick={() => this.carrier('/user/profile')} className="username"><Image className="avatar logo" src={logo} circle /></a>
                <span className="logo">موتور جستجوی اسب اصیل</span>
              </Col>
            </Row>}
          {isAuthenticated && user.currentUser &&
            <Row className="item-menu">
              <a onClick={() => this.carrier('/user/dashboard')}>
                <Col xs={3}><MdDashboard /></Col>
                <Col xs={9}>داشبورد</Col>
              </a>
              <a onClick={() => this.carrier('/user/profile-edit')}>
                <Col xs={3}><FaPencil /></Col>
                <Col xs={9}>ویرایش پروفایل</Col>
              </a>
              <a onClick={() => this.carrier('/user/change-password')}>
                <Col xs={3}><MdLockOutline /></Col>
                <Col xs={9}>تغییر رمز عبور</Col>
              </a>
              <a onClick={logout}>
                <Col xs={3}><FaSingOut /></Col>
                <Col xs={9}>خروج</Col>
              </a>
            </Row>
          }
          {!isAuthenticated && <Row className="item-menu">
            <a onClick={() => this.carrier('/signup')}>
              <Col xs={3}><MdPersonAdd /></Col>
              <Col xs={9}>ثبت نام</Col>
            </a>
            <a onClick={() => this.carrier('/login')}>
              <Col xs={3}><FaSingIn /></Col>
              <Col xs={9}>ورود</Col>
            </a>
          </Row>}

          <Row className="item-menu">
            <a onClick={() => this.carrier('/new-horse')}>
              <Col xs={3}><IahoAddHorse /></Col>
              <Col xs={9}>ثبت اسب جدید</Col>
            </a>
            <a onClick={() => this.carrier('/new-features')}>
              <Col xs={3}><MdLoupe /></Col>
              <Col xs={9}>ویژگی‌های پیشنهادی</Col>
            </a>
            <a onClick={() => this.carrier('/ads')}>
              <Col xs={3}><MdStars /></Col>
              <Col xs={9}>آگهی‌ها</Col>
            </a>
            <a onClick={() => this.carrier('/store')}>
              <Col xs={3}><MdShoppingCart /></Col>
              <Col xs={9}>فروشگاه</Col>
            </a>
            <a onClick={() => this.carrier('/donate')}>
              <Col xs={3}><MdFavorite /></Col>
              <Col xs={9}>حمایت</Col>
            </a>
          </Row>
          <Row className="item-menu">
            <a onClick={() => this.carrier('/page/terms-of-service')}>
              <Col xs={3}><FaBalanceScale /></Col>
              <Col xs={9}>قوانین سرویس</Col>
            </a>
            <a onClick={() => this.carrier('/page/about')}>
              <Col xs={3}><FaFlag /></Col>
              <Col xs={9}>درباره ما</Col>
            </a>
          </Row>

          <Row id="telegram" className="item-menu">
            <Col>
              <a href="https://t.me/joinchat/AAAAAEFiX3M1rkQ5EUMAyA" target="_blank">
                <FaTelegram height="1.6em" width="1.6em" />
              </a>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

MobileNavigation.contextTypes = {
  router: React.PropTypes.object
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    user: state.user
  }
}

export default connect(mapStateToProps)(MobileNavigation)



// WEBPACK FOOTER //
// ./src/components/Common/NavigationLinks/MobileNavigation.js